import React from 'react'
import shopforpet from "../images/BANNER_SHOP FOR Dog.jpg";
import flat20off from "../images/flat20off.jpg"
import healthcare from "../images/Healthcare new.jpg";
import winter from "../images/winter.jpg";

function Slider() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
   
      <img src={winter} className="d-block w-100" alt="winter"/>
     
    </div>
      <div className="carousel-item">
           <a href='healthproducts'>
      <img src={healthcare} className="d-block w-100" alt="healthcare"/>
       </a>
    </div>
    <div className="carousel-item">
      <img src={flat20off} className="d-block w-100" alt="flat20off pet products"/>
    </div>
    <div className="carousel-item">
      <img src={shopforpet} className="d-block w-100" alt="shopforpet"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider